import { Bot, Search, TrendingUp, Quote } from "lucide-react";

export const GeoVsSeoKeyFindings = () => {
  const findings = [
    {
      icon: Bot,
      stat: "40%",
      title: "Searches Now Involve AI",
      description: "Between ChatGPT, Perplexity, Claude, and Gemini, an estimated 40% of information-seeking queries now go through AI first. Users ask AI, then verify with Google—or skip Google entirely.",
      color: "text-primary",
      bgColor: "bg-primary/10",
    },
    {
      icon: Quote,
      stat: "Citations",
      title: "AI Cites Authoritative Sources",
      description: "LLMs cite sources they consider authoritative. Unlike backlinks, AI citations depend on clear definitions, structured data, FAQ schemas, and content that directly answers questions.",
      color: "text-chart-2",
      bgColor: "bg-chart-2/10",
    },
    {
      icon: Search,
      stat: "Different",
      title: "Different Ranking Signals",
      description: "Google ranks based on backlinks, keywords, and engagement. AI models rank based on training data, structured content, definitional clarity, and source credibility. The overlap is smaller than you'd think.",
      color: "text-chart-4",
      bgColor: "bg-chart-4/10",
    },
    {
      icon: TrendingUp,
      stat: "2x",
      title: "GEO Content Gets More Visibility",
      description: "Content optimized for both SEO and GEO sees 2x more visibility than SEO-only content. As AI search grows, this gap will widen. Early adopters have a significant advantage.",
      color: "text-chart-1",
      bgColor: "bg-chart-1/10",
    },
  ];

  return (
    <section className="py-8 sm:py-12">
      <h2 className="text-2xl sm:text-3xl font-display font-bold text-foreground mb-6">
        Why GEO Matters Now
      </h2>
      <p className="text-muted-foreground mb-8 max-w-3xl">
        The rise of AI-powered search has created a new discovery channel. 
        If your content isn't optimized for LLMs, you're invisible to a growing segment of searchers.
      </p>

      <div className="grid md:grid-cols-2 gap-6">
        {findings.map((finding, index) => (
          <div
            key={index}
            className="bg-card rounded-xl border border-border p-6 hover:border-primary/30 transition-colors"
          >
            <div className="flex items-start gap-4">
              <div className={`w-12 h-12 rounded-xl ${finding.bgColor} flex items-center justify-center shrink-0`}>
                <finding.icon className={`w-6 h-6 ${finding.color}`} />
              </div>
              <div>
                <div className={`text-2xl font-bold ${finding.color} mb-1`}>{finding.stat}</div>
                <h3 className="font-semibold text-foreground mb-2">{finding.title}</h3>
                <p className="text-sm text-muted-foreground leading-relaxed">{finding.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};